'use strict';

import ItemDetail from "../components/ui/search/ItemDetail";
import Loading from "../components/Loading";
import {getTimeRounded} from "../helpers/search";
import Tooltip from "../components/ui/tooltip/Tooltip";

class FlightSearchModal extends React.Component {
    
    constructor(props) {
        super(props);
        this.initState = {
            isFetching: false,
            isSubmitting: false,
            notFound: false,
            item: null,
            averagePrice: null,
            onShowBarometerClick: null,
            imageDimensions: null,
            routes: [],
            showForm: false,
            formData: {},
            errors: {},
        }
        this.state = this.initState;
    }

    componentDidMount() {
        
        const handleSelectOffer = (id, imageDimensions, initData = {}) => {
            this.setState({isFetching: true, errors: {}});
            flightAction.fetchSearchFlight({id, imageDimensions}).then(response => {
                this.setState({
                    isFetching: false,
                    notFound: response.item === null,
                    item: response.item,
                }, () => setFormData(initData, response.item));
            });
        }
        
        const setFormData = (initData = {}, item = {}) => {
            
            if (!initData.showForm) return;

            const formData = {}
            
            if (item && item.routes && item.routes.length > 0 && item.routes[0]) {
                if (item.routes[0].departTime) formData.time = getTimeRounded(item.routes[0].departTime)
                if (item.routes[0].departTimeFrom) formData.time = getTimeRounded(item.routes[0].departTimeFrom)
            }

            if ((initData.routes || []).length > 0) {
                if (initData.routes[0].date) formData.date = initData.routes[0].date
                if (initData.routes[0].time) formData.time = initData.routes[0].time
                if (initData.routes[0].seats) formData.seats = initData.routes[0].seats
                this.setState({formData});
            }
        }

        listenEvent('react.selectFlightOffer', data => {
            
            this.setState({
                imageDimensions: data.imageDimensions || null,
                routes: data.routes || [],
                showForm: data.showForm || false,
                averagePrice: data.barometer?.averagePrice || null,
                onShowBarometerClick: data.barometer?.onShowBarometerClick || null,
            });
            
            if(data.item === null) {
                this.setState(this.initState);
            } else {
                if(data.id) {
                    this.setState({imageDimensions: data.imageDimensions});
                    handleSelectOffer(data.id, data.imageDimensions, data);
                }
                if(data.item) {
                    this.setState({
                        item: data.item,
                    }, () => setFormData(data, data.item));
                }
            }
        })
    }

    getSubmitRoutes({formDatetimeFirst = false}) {
        const {item, routes} = this.state;
        let date, time;
        return item.routes.map((flightRoute, index) => {
            const searchRoute = routes && routes[index] ? routes[index] : {};
            const from = flightRoute.from;
            const to = flightRoute.to;
            const seats = searchRoute.seats || 1;
            const fleet_id = flightRoute.fleetId || null
            const arrive_date = flightRoute.arriveDate || null
            const arrive_time = flightRoute.arriveTime || null
            const flight_time = flightRoute.flightTimeClear || null

            if (!formDatetimeFirst) {
                date = flightRoute.departDateFrom || flightRoute.departDate || searchRoute.date;
                time = flightRoute.departTimeFrom || flightRoute.departTime || searchRoute.time;
            } else {
                date = searchRoute.date || flightRoute.departDateFrom || flightRoute.departDate;
                time = searchRoute.time || flightRoute.departTimeFrom || flightRoute.departTime;
            }
            
            return {from, to, date, time, seats, fleet_id, arrive_date, arrive_time, flight_time}
        })
    }

    handleSubmit(form) {
        
        const {item} = this.state;

        if(!checkAuth()) return;

        this.setState({isSubmitting: true});

        let data = {
            type: item.type,
            routes: this.getSubmitRoutes({formDatetimeFirst: item.type === 'emptyleg'}),
            id: isNaN(parseInt(item.id)) ? null : item.id, // Если только цифры, тогда считается, что есть
            offerId: item.offer_id || null,
            selectedClasses: item.aircraft.class.id ? [item.aircraft.class.id] : null,
            selectedAircrafts: item.aircraft.id ? [item.aircraft.id] : null,
        };
        data = Object.fromEntries(
            Object.entries(data).filter(([key, value]) => value !== null)
        );

        if(item.type === 'barometer') {
            data.extId = item.ext_id;
            data.price = item.prices.price;
            data.currency = item.prices.currency.code;
            data.aircraft = {
                title: item.aircraft.title,
                year: item.aircraft.year,
            }
        }

        if(form) {
            this.setState({formData: form})
            data.date = form.date;
            data.time = form.time;
            data.seats = form.seats;
        }
        
        (data.id ? requestAction.submitFlight(data) : requestAction.submitRequest(data)).then(response => {
            this.setState({isSubmitting: false});
            if (response.status === 'success') {
                $.fancybox.close();
                successPopup(item.type, () => {
                    $('body, html').animate({scrollTop: 0}, 500);
                    raiseEvent('toggleSideBeard', {state: {type: 'requests', tab: 'current', filter: 'all'}});
                })
            } else if(response.errors) {
                this.setState({errors: response.errors});
            }
        });
    }
    
    render() {
        const {isFetching, isSubmitting, notFound, item, averagePrice, onShowBarometerClick, imageDimensions, showForm, formData, errors} = this.state;
        
        return <React.Fragment>
            
            <Loading active={isFetching} absolute={false}/>

            {(!isFetching && notFound) && <div style={{height: '200px'}}>
                <div className="notFound">{tMsg('Данный рейс более недоступен')}</div>
            </div>}

            {!isFetching && item && <ItemDetail 
                item={item} 
                imageSize={imageDimensions}
                showForm={showForm}
                averagePrice={averagePrice}
                showPriceModal={true}
                formDataInit={formData}
                errors={errors}
                isSubmitting={isSubmitting}
                onSubmit={(form) => this.handleSubmit(form)}
                onShowBarometerClick={onShowBarometerClick}
            />}

            <Tooltip />
            
        </React.Fragment>
    }
}

const domContainer = document.querySelector('#reactFlightSearchModal');
const root = ReactDOM.createRoot(domContainer);
root.render(React.createElement(FlightSearchModal));
